import { render, staticRenderFns } from "./Dog-documents.vue?vue&type=template&id=7c1bebcc&scoped=true&"
import script from "./Dog-documents.vue?vue&type=script&lang=js&"
export * from "./Dog-documents.vue?vue&type=script&lang=js&"
import style0 from "./Dog-documents.vue?vue&type=style&index=0&id=7c1bebcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1bebcc",
  null
  
)

export default component.exports